import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { IPaginador } from '@infotrack/presentacion-transversales/interfacesComunes';

import IDocumentoFiltro from '../../../../modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';
import IDocumento from '../../../../modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from '../../../../modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import ModeloTraslados from '../../../../modelos/negocioRefactor/modelos/Traslados/ModeloTraslados';
import TiposProceso from 'Infotrack@Modelos/negocioRefactor/enumeraciones/TiposProceso';
import IDocumentoBaseConsulta from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoBaseConsulta';
import IDocumentoAplicacion from 'Infotrack@Modelos/negocioRefactor/entidades/negocio/IDocumentoAplicacion';
import { IDocumentoFirma } from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoFirma';

class TrasladosCM {
    private modeloTraslados: ModeloTraslados;

    constructor() {
        this.modeloTraslados = new ModeloTraslados();
    }

    public async editarDetalle(detalle: IDocumentoDetalle) {
        if (!this.validarDetalle(detalle)) return false;
        const respuesta = await this.modeloTraslados.editarDetalle(detalle);
        return respuesta.data.Resultado;
    }

  

    public async eliminarDetalle(detalle: IDocumentoDetalle) {
        const respuesta = await this.modeloTraslados.eliminarDetalle(detalle);
        return respuesta.data.Resultado;
    }

    public async guardarDetalle(detalles: IDocumentoDetalle[]) {
        if (detalles.some((detalle) => !this.validarDetalle(detalle))) return false;
        const respuesta = await this.modeloTraslados.guardarDetalle(detalles);
        return respuesta.data.Resultado;
    }

    public async guardarEncabezado(documento: IDocumento) {
        const respuesta = await this.modeloTraslados.guardarEncabezado(documento);
        return respuesta.data;
    }

    public async editarEncabezado(documento: IDocumento) {
        const respuesta = await this.modeloTraslados.editarEncabezado(documento);
        return respuesta.data;
    }

    public async anularDocumento(documentoId: string) {
        const respuesta = await this.modeloTraslados.anularDocumento(documentoId);
        return respuesta.data.Resultado;
    }

    public consultarListaDocumentos = async (paginador: IPaginador, filtro: IDocumentoFiltro) => {
        filtro.idTipoProceso = TiposProceso.TRASLADO;
        const respuesta = await this.modeloTraslados.consultarListaDocumentos({
            Filtro: filtro,
            Paginador: paginador,
        });
        return respuesta.data;
    };

    public async consultarDetallesDocumento(filtro: Partial<IDocumentoDetalle>) {
        const respuesta = await this.modeloTraslados.consultarDetallesDocumento(filtro);
        return respuesta.data.Entidades;
    }

    public async consultarEncabezadoDocumento(filtro: Partial<IDocumento>) {
        const respuesta = await this.modeloTraslados.consultarEncabezadoDocumento(filtro);
        return respuesta.data.Entidades[0];
    }

    public async consultarEtapas(documentoId: string) {
        const respuesta = await this.modeloTraslados.consultarEtapas(documentoId);
        return respuesta.data.Entidades;
    }

    public async cambiarEtapa(documento: Partial<IDocumentoAplicacion>,idUsuario:string) {
        const respuesta = await this.modeloTraslados.cambiarEtapa(documento,idUsuario);
        return respuesta.data.Resultado;
    }

    public async consultarDocumentoBase(documentoBase: IDocumentoBaseConsulta) {
        const respuesta = await this.modeloTraslados.consultarDocumentoBaseTraslados(documentoBase);
        return respuesta.data.Entidades;
    }

    public async generarArchivoPDF(documentoId: string, idAplicacion: string) {
        const respuesta = await this.modeloTraslados.consultarPdfDocumento(documentoId, idAplicacion);
        return respuesta.data.Entidades[0] ;
    }

    public async guardarDocumentoFirma(documentoFirma: IDocumentoFirma) {
        const respuesta = await this.modeloTraslados.guardarDocumentoFirma(documentoFirma);
        return respuesta.data.Entidades[0] ;
    }

    public validarEntidad(documento: IDocumento): boolean {
        if (
            documento.BodegaDestino === undefined ||
            documento.BodegaOrigen === undefined ||
            documento.TipoDocumentoId === 0||
            documento.DocumentoRelacionado === ""
        ) {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
    private validarDetalle(detalle: IDocumentoDetalle) {
        
        if (!detalle.DivisionDestino) {
            notificacionGlobal('ModalRecepcion.ValidacionNoDivisionDestino', 3000, 'warning', true);
            return false;
        }
        return true;
    }

    


}
export default TrasladosCM;
